var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("common-content", [
        _c(
          "div",
          { staticClass: "project-detail-title" },
          [
            _c("nuxt-link", { attrs: { to: "/news" } }, [
              _c("h4", [_vm._v(_vm._s(_vm.pro))])
            ]),
            _c("h2", { staticClass: "project-name" }, [
              _vm._v(_vm._s(_vm.pageData.title))
            ]),
            _c("h6", [_vm._v(_vm._s(_vm.pageData.time))])
          ],
          1
        ),
        _c("div", { staticClass: "newsDetail" }, [
          _c("img", { attrs: { src: _vm.pageData.mainImg, alt: "" } }),
          _c("div", {
            staticClass: "content",
            domProps: { innerHTML: _vm._s(_vm.contents) }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b11b6f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b11b6f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/news/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2b11b6f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/news/_id.vue
// module chunks = 11